import React from 'react';
import { useSelector } from 'react-redux';

import ElementSpacePlaceholder from 'components/ElementSpacePlaceholder';
import ErrorLayout from 'components/ErrorLayout';
import GlobalLoader from 'components/GlobalLoader';
import Loader from 'components/Loader';
import styles from './SubmittedTable.module.scss';
import Table from 'components/Table';
import TableBody from 'components/TableBody';
import SubmittedTableHeader from '../SubmittedTableHeader';
import SubmittedTableRow from '../SubmittedTableRow';
import {
  currentPageSelector,
  NeovarsityManagementPagination,
  useGetCapstoneSubmissionsQuery,
} from 'features/neovarsityManagement';

function SubmittedTable() {
  const currentPage = useSelector(currentPageSelector);
  const { data, isLoading, error, refetch, isFetching } =
    useGetCapstoneSubmissionsQuery({
      type: 'submission',
      page: currentPage,
    });

  if (isLoading) {
    return <Loader />;
  } else if (error) {
    return (
      <ErrorLayout
        title="Failed to load capstone submissions"
        message={error.data?.message || 'Something went wrong! Try again later'}
        actionFn={refetch}
      />
    );
  } else if (data?.data?.length > 0) {
    const capstoneSubmissions = data.data;

    return (
      <>
        <GlobalLoader isVisible={isFetching} />
        <Table className={styles.root}>
          <SubmittedTableHeader />
          <TableBody className={styles.rows}>
            {capstoneSubmissions?.map((submission) => (
              <SubmittedTableRow
                submission={submission}
                key={submission.id}
              />
            ))}
          </TableBody>
        </Table>
        <ElementSpacePlaceholder elementId="submitted-submission-pagination" />
        <div
          id="submitted-submission-pagination"
          className={styles.pagination}
        >
          <NeovarsityManagementPagination
            pageCount={data.meta.total_pages}
            currentPage={currentPage}
          />
        </div>
      </>
    );
  } else {
    return (
      <ErrorLayout
        title="No capstone submissions found!"
        message="No submissions to take actions on at the moment!"
      />
    );
  }
}

export default SubmittedTable;
